import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ChatBotEventType } from './types/chat-bot-event.enum';
import { ChatBotStateService } from './chat-bot-state.service';
import { FeedbackResponseDTO } from 'app/teacher-feedback/teacher-feedback-service/private-class-feedback-dto';
import { GTMService } from './gtm.service';
import { ChatBotTrackEvents } from './types/chat-bot-track-events.enum';
import { ChatBotTypes } from './types/chat-bot-types.enum';

export const START_FEEDBACK_PRACTICE_KEY = 'startFeedbackPractice';
type Message = { type: ChatBotEventType, data?: any };

@Injectable({ providedIn: 'root' })
export class ChatBotEventService {
  private messages$$ = new BehaviorSubject<Message | null>(null);
  public messages$ = this.messages$$.asObservable();

  constructor(
    private readonly chatBotStateService: ChatBotStateService,
    private readonly gtmService: GTMService
  ) {}

  public init() {
    this.feedbackPracticeMonitor();
  }

  private sendEvent(message: Message) {
    this.messages$$.next(message);
  }

  private feedbackPracticeMonitor() {
    const externalClassroomId = window.sessionStorage.getItem(START_FEEDBACK_PRACTICE_KEY);
    if (externalClassroomId) {
      this.startPractice(externalClassroomId);
      window.sessionStorage.removeItem(START_FEEDBACK_PRACTICE_KEY);
    }
  }

  public startPractice(externalClassroomId: FeedbackResponseDTO['externalClassroomId'], propagationTime = 0) {
    this.chatBotStateService.openChatBotLcFeedbackModal();
    setTimeout(() => {
      this.sendEvent({ type: ChatBotEventType.CHAT_BOT_START_PRACTICE_EVENT, data: {
        type: ChatBotTypes.LC_FEEDBACK,
        externalClassroomId
      }});
    }, propagationTime);
    this.gtmService.sendGA4Event(ChatBotTrackEvents.AI_FEEDBACK_PRACTICE);
  }

  public clearEvent() {
    this.messages$$.next(null);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/chat-bot-event.service.ts